import { IconButton, styled } from '@mui/material';

export const OutlinedIconButton = styled(IconButton)(({ theme }) => ({
  width: 40,
  height: 40,
  borderRadius: 6,
  border: `1px solid ${theme.palette.mb.control}`,
  color: theme.palette.mb.muted,
  backgroundColor: theme.palette.mb.surface,
  '&:hover': { backgroundColor: theme.palette.mb.ground },
}));
